import type {
  Workflow,
  WorkflowScope,
} from "@stockline/shared/types/ai/workflow"
import { WORKFLOW_TABLE } from "../../../lib/offline/resources/ai/workflow/db"
import { useAISync } from "../providers/AISyncProvider"

export interface UseWorkflowsFilter {
  scope?: WorkflowScope
  isActive?: boolean
}

export function useWorkflows(filter?: UseWorkflowsFilter): Workflow[] {
  const { reactive } = useAISync()
  return reactive.useQuery<Workflow>(WORKFLOW_TABLE, {
    ...filter,
    orderBy: "-updatedAt",
  })
}
